import React, { lazy, Suspense, useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import useColor from '../../../../hooks/site/useColor';
import useBootstrapSize from '../../../../hooks/useBootstrapSize';
import { IconPin, IconPinFilled } from '@tabler/icons-react';
import { ENUM_LOCALSTORAGE, ENUM_USERS_TYPE, TEST_MODE } from '../../../../enums/enums';
import CusItemTooltip from '../../../../components/material-ui/CusItemTooltip';
import FinancePieChart from './FinancePieChart';
import InformationLinks from './InformationLinks';
import MenuContainer from './MenuContainer';
import { useLocalStorage } from 'usehooks-ts';
import { API_USERS } from '../../../../api/users';
import { useAppSelector } from '../../../../store';
import PinElement from '../../../../components/material-ui/PinElement';
import { dispatchCusEvent } from '../../../../utils';

const AccountInfo = lazy(() => import('./AccountInfo'));
const MenuActions = lazy(() => import('./MenuActions'));

export default function UsersMenu({
  maxHeight,
  openMobileMenu,
  setOpenMobileMenu,
  usersContentRef
}) {
  const { isLessTablet } = useBootstrapSize();
  const { primary } = useColor();

  const selectUserInfo = useAppSelector((state) => state.users.list.selectUser);
  const [pined, setPined] = useLocalStorage(ENUM_LOCALSTORAGE.pinUserMenu, true);
  const [selectUserFull, setSelectUserFull] = useState({});

  const userId = selectUserInfo.userId;
  const isGamer = selectUserInfo.type == ENUM_USERS_TYPE.gamer;

  useEffect(() => {
    setSelectUserFull({});

    if (!userId) return;
    if (TEST_MODE) {
      const selectUserFull = { ...selectUserInfo, userId };
      setSelectUserFull(selectUserFull);
      dispatchCusEvent('userMenu.userInfo.get', { selectUserFull });
      return;
    }

    API_USERS.info
      .get({ userId })
      .then((e) => {
        const data = e.data.data;
        const selectUserFull = { ...selectUserInfo, ...data, userId };
        setSelectUserFull(selectUserFull);
        dispatchCusEvent('userMenu.userInfo.get', { selectUserFull });
      })
      .catch(console.error);
  }, [userId]);

  return (
    <MenuContainer
      maxHeight={maxHeight}
      openMobileMenu={openMobileMenu}
      setOpenMobileMenu={setOpenMobileMenu}
      usersContentRef={usersContentRef}
      pined={pined}>
      <Suspense>
        <AccountInfo
          selectUserFull={selectUserFull}
          setSelectUserFull={setSelectUserFull}
          PinElement={() => (
            <PinElement pined={pined} setPined={setPined} conditionPin={!isLessTablet} />
          )}
        />
      </Suspense>
      <ShowContainer condition={Object.keys(selectUserFull).length}>
        <ShowContainer condition={isGamer}>
          <FinancePieChart userId={userId} defaultCurrency={selectUserFull.currency} />
        </ShowContainer>

        <InformationLinks selectUserFull={selectUserFull} />
      </ShowContainer>

      <Suspense>
        <MenuActions user={selectUserFull} setSelectUserFull={setSelectUserFull} />
      </Suspense>
    </MenuContainer>
  );
}
